// extracted by mini-css-extract-plugin
module.exports = {"topRibbon":"_2hLqVkCSiocJrTELsHsy6f","icon":"_3dPh1Llplt2sIUW7rSf1O3"};